import { render, staticRenderFns } from "./BusinessLayout.vue?vue&type=template&id=0a042462&scoped=true&"
import script from "./BusinessLayout.vue?vue&type=script&lang=js&"
export * from "./BusinessLayout.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLayout.vue?vue&type=style&index=0&id=0a042462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a042462",
  null
  
)

export default component.exports